// Endocrine subsection form field enum
export enum EndocrineFormField {
  ENDOCRINE_ENDOCRINE_WNL = 'medicalBackground/endocrine/endocrineWnl',
  ENDOCRINE_MENSTRUAL_CYCLE = 'medicalBackground/endocrine/menstrualCycle',
  ENDOCRINE_MENSTRUAL_DATE = 'medicalBackground/endocrine/menstrualDate',
  ENDOCRINE_ENDOCRINE_NOTES = 'medicalBackground/endocrine/endocrineNotes',
  ENDOCRINE_SYSTEM_SUMMARY = 'medicalBackground/endocrine/systemSummary'
}
